import * as React from "react";
const SvgFiRrBath = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bath_svg__a)">
      <path
        fill="#062147"
        d="M23.249 13.015A3 3 0 0 0 21 12H2V4.482c0-.84.38-1.673 1.093-2.12a2.33 2.33 0 0 1 3.107.571l.259.345-.483 2.771a1.354 1.354 0 0 0 2.146 1.315l3.606-2.704c.567-.425.71-1.217.327-1.814l-.013-.02a1.36 1.36 0 0 0-1.079-.623l-2.906-.129-.174-.232C7.225.965 6.29.3 5.214.087A4.34 4.34 0 0 0 0 4.333l.006 7.923c0 .576.037 1.145.108 1.717l.237 1.9a8.12 8.12 0 0 0 2.635 5.037l-.457 1.85a1 1 0 1 0 1.941.48l.277-1.12a8.1 8.1 0 0 0 3.676.88h7.417a8.1 8.1 0 0 0 3.44-.765l.249 1.005a1 1 0 0 0 1.941-.48l-.41-1.66a8.12 8.12 0 0 0 2.854-5.226l.062-.5a3 3 0 0 0-.728-2.358zm-1.257 2.11-.062.5A6.146 6.146 0 0 1 15.841 21H8.424a6.145 6.145 0 0 1-6.088-5.375L2.133 14H21c.291 0 .558.12.75.338a1 1 0 0 1 .242.786"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bath_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBath;
